// extracted by mini-css-extract-plugin
export default {"pageTitle":"create-resource-type_pageTitle__qc1Cw"};